<device-sentilo-config>
      <!-- Card: Configuración Sentilo/Dival -->
            <div class="card h-100 device-detail-support-card" if={ shouldShowSentiloSection() }>
          <div class="card-header bg-white d-flex justify-content-between align-items-center">
            <span class="fw-semibold">Integración Sentilo</span>
            <!-- Solo admins pueden editar la configuración -->
            <button
              class="btn btn-sm btn-outline-primary"
              onclick={ toggleSentiloEditMode }
              if={ props.isadmin && !state.sentiloEditMode }>
              <i class="bi bi-pencil me-1"></i> Editar
            </button>
          </div>
          <div class="card-body device-detail-support-card-body">
            <!-- View mode -->
            <div if={ !state.sentiloEditMode }>
              <div if={ !props.device.sentiloConfig || !props.device.sentiloConfig.enabled }>
                <p class="text-muted">
                  <i class="bi bi-x-circle me-2"></i>
                  Sentilo no está habilitado para este dispositivo
                </p>
              </div>

              <div if={ props.device.sentiloConfig && props.device.sentiloConfig.enabled }>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item d-flex align-items-center">
                    <i class="bi bi-check-circle-fill text-success me-2"></i>
                    <strong>Estado:</strong>
                    <span class="ms-2 badge bg-success">Activo</span>
                  </li>
                  <li class="list-group-item">
                    <strong>Componente:</strong>
                    <code class="ms-2">{ props.device.sentiloConfig.componentName || 'No configurado' }</code>
                  </li>
                  <li class="list-group-item">
                    <strong>Ubicación GPS:</strong>
                    <span class="ms-2">{ props.device.sentiloConfig.location || 'No configurada' }</span>
                  </li>
                  <li class="list-group-item">
                    <div class="mb-2 d-flex justify-content-between align-items-center">
                      <strong>Sensores configurados:</strong>
                      <!-- Status badge and refresh button -->
                      <div class="d-flex align-items-center gap-2">
                        <span if={ state.sentiloStatus.loading } class="badge bg-secondary">
                          <i class="bi bi-arrow-repeat spin me-1"></i> Verificando...
                        </span>
                        <span if={ !state.sentiloStatus.loading && state.sentiloStatus.checked && state.sentiloStatus.allSensorsRegistered } class="badge bg-success">
                          <i class="bi bi-cloud-check me-1"></i> Registrados en Sentilo
                        </span>
                        <span if={ !state.sentiloStatus.loading && state.sentiloStatus.checked && state.sentiloStatus.someSensorsRegistered && !state.sentiloStatus.allSensorsRegistered } class="badge bg-warning text-dark">
                          <i class="bi bi-exclamation-triangle me-1"></i> Parcialmente registrados
                        </span>
                        <span if={ !state.sentiloStatus.loading && state.sentiloStatus.checked && !state.sentiloStatus.someSensorsRegistered && state.sentiloStatus.sensors.length > 0 } class="badge bg-danger">
                          <i class="bi bi-cloud-slash me-1"></i> No registrados
                        </span>
                        <span if={ !state.sentiloStatus.loading && state.sentiloStatus.error } class="badge bg-warning text-dark" title={ state.sentiloStatus.error }>
                          <i class="bi bi-exclamation-circle me-1"></i> Error
                        </span>
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-secondary"
                          onclick={ handleRefreshSentiloStatus }
                          disabled={ state.sentiloStatus.loading }
                          title="Verificar estado en Sentilo">
                          <i class="bi bi-arrow-clockwise"></i>
                        </button>
                      </div>
                    </div>
                    <div class="ms-3">
                      <div class="d-flex align-items-center mb-2">
                        <i class="bi bi-{ props.device.sentiloConfig.sensors?.out0?.enabled ? 'check-circle-fill text-success' : 'x-circle text-muted' } me-2"></i>
                        <strong>OUT0:</strong>
                        <code class="ms-2">{ props.device.sentiloConfig.sensors?.out0?.sensorName || 'No configurado' }</code>
                        <span class="ms-2 text-muted small" if={ props.device.sentiloConfig.sensors?.out0?.description }>
                          ({ props.device.sentiloConfig.sensors.out0.description })
                        </span>
                        <!-- Sentilo registration status for out0 -->
                        <span if={ getSensorRegistrationStatus('out0') === 'registered' } class="ms-2 badge bg-success-subtle text-success">
                          <i class="bi bi-cloud-check"></i> En Sentilo
                        </span>
                        <span if={ getSensorRegistrationStatus('out0') === 'not-registered' } class="ms-2 badge bg-danger-subtle text-danger">
                          <i class="bi bi-cloud-slash"></i> No en Sentilo
                        </span>
                      </div>
                      <div class="d-flex align-items-center">
                        <i class="bi bi-{ props.device.sentiloConfig.sensors?.out1?.enabled ? 'check-circle-fill text-success' : 'x-circle text-muted' } me-2"></i>
                        <strong>OUT1:</strong>
                        <code class="ms-2">{ props.device.sentiloConfig.sensors?.out1?.sensorName || 'No configurado' }</code>
                        <span class="ms-2 text-muted small" if={ props.device.sentiloConfig.sensors?.out1?.description }>
                          ({ props.device.sentiloConfig.sensors.out1.description })
                        </span>
                        <!-- Sentilo registration status for out1 -->
                        <span if={ getSensorRegistrationStatus('out1') === 'registered' } class="ms-2 badge bg-success-subtle text-success">
                          <i class="bi bi-cloud-check"></i> En Sentilo
                        </span>
                        <span if={ getSensorRegistrationStatus('out1') === 'not-registered' } class="ms-2 badge bg-danger-subtle text-danger">
                          <i class="bi bi-cloud-slash"></i> No en Sentilo
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>

                <!-- Register sensors button -->
                <div class="mt-3 pt-3 border-top">
                  <button
                    type="button"
                    class="btn btn-outline-success"
                    onclick={ handleRegisterSentiloSensors }
                    disabled={ state.registeringSentilo || !hasSentiloSensorsConfigured() }>
                    <i class="bi bi-cloud-upload me-1"></i>
                    { state.registeringSentilo ? 'Registrando...' : 'Registrar sensores en Sentilo' }
                  </button>
                  <div class="form-text mt-2">
                    <i class="bi bi-info-circle me-1"></i>
                    Registra los sensores configurados en la plataforma Sentilo/Dival.
                    Debe hacerse una vez antes de enviar datos.
                  </div>
                </div>
              </div>
            </div>

            <!-- Edit mode - Solo para admins -->
            <form if={ state.sentiloEditMode && props.isadmin } onsubmit={ handleSaveSentiloConfig }>
              <div class="mb-3">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="sentiloEnabled"
                    name="enabled"
                    checked={ state.sentiloEditData.enabled }
                    onchange={ handleSentiloEditInput }>
                  <label class="form-check-label" for="sentiloEnabled">
                    <strong>Habilitar Sentilo</strong>
                  </label>
                </div>
              </div>

              <div if={ state.sentiloEditData.enabled }>
                <div class="mb-3">
                  <label for="componentName" class="form-label">Nombre del Componente <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    class="form-control font-monospace { state.errors['componentName'] ? 'is-invalid' : '' }"
                    id="componentName"
                    name="componentName"
                    value={ state.sentiloEditData.componentName }
                    oninput={ handleSentiloEditInput }
                    placeholder="DoorOpenerBOTDISC01">
                  <div class="invalid-feedback" if={ state.errors['componentName'] }>{ state.errors['componentName'] }</div>
                  <div class="form-text">Identificador único del componente en Sentilo</div>
                </div>

                <div class="mb-3">
                  <label for="location" class="form-label">Ubicación GPS <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    class="form-control { state.errors['location'] ? 'is-invalid' : '' }"
                    id="location"
                    name="location"
                    value={ state.sentiloEditData.location }
                    oninput={ handleSentiloEditInput }
                    placeholder="39.273787 -0.572836">
                  <div class="invalid-feedback" if={ state.errors['location'] }>{ state.errors['location'] }</div>
                  <div class="form-text">Formato: latitud longitud (separados por espacio)</div>
                </div>

                <hr class="my-4">

                <!-- Sensor OUT0 -->
                <h6 class="mb-3">Sensor OUT0 (Puerta 1)</h6>
                <div class="mb-3">
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="out0Enabled"
                      name="sensors.out0.enabled"
                      checked={ state.sentiloEditData.sensors.out0.enabled }
                      onchange={ handleSentiloEditInput }>
                    <label class="form-check-label" for="out0Enabled">
                      Habilitar notificaciones OUT0
                    </label>
                  </div>
                </div>

                <div if={ state.sentiloEditData.sensors.out0.enabled } class="ms-4">
                  <div class="mb-3">
                    <label for="out0SensorSuffix" class="form-label">Nombre del Sensor <span class="text-danger">*</span></label>
                    <div class="input-group">
                      <span class="input-group-text font-monospace bg-light" title="Prefijo basado en el nombre del componente">
                        { getSensorPrefix() }
                      </span>
                      <input
                        type="text"
                        class="form-control font-monospace text-uppercase { state.errors['sensors.out0.sensorSuffix'] ? 'is-invalid' : '' }"
                        id="out0SensorSuffix"
                        name="sensors.out0.sensorSuffix"
                        value={ state.sentiloEditData.sensors.out0.sensorSuffix }
                        oninput={ handleSentiloEditInput }
                        placeholder="S01"
                        maxlength="3"
                        style="max-width: 80px;"
                        title="Formato: S seguido de 2 dígitos (ej: S01, S02)">
                    </div>
                    <div class="invalid-feedback d-block" if={ state.errors['sensors.out0.sensorSuffix'] }>{ state.errors['sensors.out0.sensorSuffix'] }</div>
                    <div class="form-text">
                      <i class="bi bi-info-circle me-1"></i>
                      Formato requerido: <strong>S + 2 dígitos</strong> (ej: S01, S02). Nombre completo: <code>{ getFullSensorName('out0') }</code>
                    </div>
                  </div>

                    <div class="mb-3">
                      <label for="out0Description" class="form-label">Descripción</label>
                      <input
                        type="text"
                        class="form-control"
                        id="out0Description"
                        name="sensors.out0.description"
                        value={ state.sentiloEditData.sensors.out0.description }
                        oninput={ handleSentiloEditInput }
                        placeholder="Puerta 1 de entrada principal">
                    </div>
                  </div>

                  <hr class="my-4">

                  <!-- Sensor OUT1 -->
                  <h6 class="mb-3">Sensor OUT1 (Puerta 2)</h6>
                  <div class="mb-3">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="out1Enabled"
                        name="sensors.out1.enabled"
                        checked={ state.sentiloEditData.sensors.out1.enabled }
                        onchange={ handleSentiloEditInput }>
                      <label class="form-check-label" for="out1Enabled">
                        Habilitar notificaciones OUT1
                      </label>
                    </div>
                  </div>

                  <div if={ state.sentiloEditData.sensors.out1.enabled } class="ms-4">
                    <div class="mb-3">
                      <label for="out1SensorSuffix" class="form-label">Nombre del Sensor <span class="text-danger">*</span></label>
                      <div class="input-group">
                        <span class="input-group-text font-monospace bg-light" title="Prefijo basado en el nombre del componente">
                          { getSensorPrefix() }
                        </span>
                        <input
                          type="text"
                          class="form-control font-monospace text-uppercase { state.errors['sensors.out1.sensorSuffix'] ? 'is-invalid' : '' }"
                          id="out1SensorSuffix"
                          name="sensors.out1.sensorSuffix"
                          value={ state.sentiloEditData.sensors.out1.sensorSuffix }
                          oninput={ handleSentiloEditInput }
                          placeholder="S02"
                          maxlength="3"
                          style="max-width: 80px;"
                          title="Formato: S seguido de 2 dígitos (ej: S01, S02)">
                      </div>
                      <div class="invalid-feedback d-block" if={ state.errors['sensors.out1.sensorSuffix'] }>{ state.errors['sensors.out1.sensorSuffix'] }</div>
                      <div class="form-text">
                        <i class="bi bi-info-circle me-1"></i>
                        Formato requerido: <strong>S + 2 dígitos</strong> (ej: S01, S02). Nombre completo: <code>{ getFullSensorName('out1') }</code>
                      </div>
                    </div>

                    <div class="mb-3">
                      <label for="out1Description" class="form-label">Descripción</label>
                      <input
                        type="text"
                        class="form-control"
                        id="out1Description"
                        name="sensors.out1.description"
                        value={ state.sentiloEditData.sensors.out1.description }
                        oninput={ handleSentiloEditInput }
                        placeholder="Puerta 2 de salida lateral">
                    </div>
                  </div>
                </div>

                <div class="mt-4">
                  <button type="submit" class="btn btn-primary me-2" disabled={ state.savingSentilo }>
                    <i class="bi bi-check me-1"></i> { state.savingSentilo ? 'Guardando...' : 'Guardar configuración' }
                  </button>
                  <button type="button" class="btn btn-outline-secondary" onclick={ toggleSentiloEditMode } disabled={ state.savingSentilo }>
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>


  <script>
    import { DeviceService } from '../services';
    import { ToastService } from '../services/toast-service';

    export default {
      onBeforeMount(props) {
        this.state = {
          sentiloEditMode: false,
          sentiloEditData: {
            enabled: false,
            componentName: '',
            location: '',
            sensors: {
              out0: { enabled: false, sensorSuffix: 'S01', description: '' },
              out1: { enabled: false, sensorSuffix: 'S02', description: '' }
            }
          },
          savingSentilo: false,
          registeringSentilo: false,
          errors: {},
          sentiloStatus: {
            loading: false,
            checked: false,
            error: null,
            allSensorsRegistered: false,
            someSensorsRegistered: false,
            sensors: []
          }
        };
      },

      onMounted() {
        if (this.props.device && this.props.device.sentiloConfig?.enabled) {
          this.checkSentiloStatus(this.props.device._id);
        }
      },

      // === SENTILO CONFIGURATION METHODS ===

      getUserSentiloEnabled() {
        // Check if current logged user has Sentilo enabled in their account
        // This is used to determine if the Sentilo section should be visible
        return this.state.user?.sentiloConfig?.enabled || false;
      },

      shouldShowSentiloSection() {
        // Admins always see the Sentilo section
        if (this.props.isadmin) return true;

        // Users see it if they have Sentilo enabled in their account
        if (this.props.userSentiloEnabled) return true;

        // Also show if the device already has Sentilo configured
        if (this.props.device?.sentiloConfig?.enabled) return true;

        return false;
      },

      toggleSentiloEditMode() {
        if (!this.state.sentiloEditMode) {
          // Entering edit mode: copy current config
          const currentConfig = this.props.device.sentiloConfig || {};
          const componentName = currentConfig.componentName || '';

          // Extract suffix from full sensor name (e.g., "DoorOpenerBOTDISC03S01" -> "S01")
          const extractSuffix = (fullName, componentName) => {
            if (!fullName || !componentName) return '';
            if (fullName.startsWith(componentName)) {
              return fullName.substring(componentName.length);
            }
            // If doesn't match component prefix, return as-is for backward compatibility
            return fullName;
          };

          this.update({
            sentiloEditMode: true,
            errors: {},
            sentiloEditData: {
              enabled: currentConfig.enabled || false,
              componentName: componentName,
              location: currentConfig.location || '',
              sensors: {
                out0: {
                  enabled: currentConfig.sensors?.out0?.enabled || false,
                  sensorSuffix: extractSuffix(currentConfig.sensors?.out0?.sensorName, componentName) || 'S01',
                  description: currentConfig.sensors?.out0?.description || ''
                },
                out1: {
                  enabled: currentConfig.sensors?.out1?.enabled || false,
                  sensorSuffix: extractSuffix(currentConfig.sensors?.out1?.sensorName, componentName) || 'S02',
                  description: currentConfig.sensors?.out1?.description || ''
                }
              }
            }
          });
        } else {
          // Exiting edit mode: discard changes
          this.update({ sentiloEditMode: false, errors: {} });
        }
      },

      /**
       * Get the sensor prefix (component name) for building full sensor names
       */
      getSensorPrefix() {
        return this.state.sentiloEditData?.componentName || 'ComponentName';
      },

      /**
       * Build the full sensor name from component name + suffix
       * @param {string} channel - 'out0' or 'out1'
       * @returns {string} Full sensor name (e.g., "DoorOpenerBOTDISC03S01")
       */
      getFullSensorName(channel) {
        const componentName = this.state.sentiloEditData?.componentName || '';
        const suffix = this.state.sentiloEditData?.sensors?.[channel]?.sensorSuffix || '';

        if (!componentName) {
          return '(establece nombre de componente)';
        }

        if (!suffix) {
          const defaultSuffix = channel === 'out0' ? 'S01' : 'S02';
          return componentName + defaultSuffix;
        }

        // Ensure suffix is uppercase and matches S + 2 digits format
        const normalizedSuffix = suffix.toUpperCase();

        return componentName + normalizedSuffix;
      },

      /**
       * Get the default sensor suffix based on channel
       * @param {string} channel - 'out0' or 'out1'
       * @returns {string} Default suffix (e.g., "S01" for out0, "S02" for out1)
       */
      getDefaultSensorSuffix(channel) {
        const channelNumber = parseInt(channel.replace('out', ''), 10);
        return 'S' + String(channelNumber + 1).padStart(2, '0');
      },

      handleSentiloEditInput(e) {
        const { name, value, type, checked } = e.target;
        const inputValue = type === 'checkbox' ? checked : value;
        const errors = this.clearError(name);

        if (name.includes('.')) {
          // Handle nested fields (sensors.out0.enabled, etc.)
          const parts = name.split('.');
          const newData = { ...this.state.sentiloEditData };

          if (parts.length === 2) {
            // Simple nested: sensors.out0 or similar
            newData[parts[0]] = {
              ...newData[parts[0]],
              [parts[1]]: inputValue
            };
          } else if (parts.length === 3) {
            // Deep nested: sensors.out0.enabled
            newData[parts[0]] = {
              ...newData[parts[0]],
              [parts[1]]: {
                ...newData[parts[0]][parts[1]],
                [parts[2]]: inputValue
              }
            };
          }

          this.update({ errors, sentiloEditData: newData });
        } else {
          // Top-level field
          this.update({
            errors,
            sentiloEditData: {
              ...this.state.sentiloEditData,
              [name]: inputValue
            }
          });
        }
      },

      // Devuelve una copia de los errores sin el campo indicado, para que la
      // marca de error desaparezca apenas el usuario corrige el dato
      clearError(name) {
        if (!this.state.errors || !this.state.errors[name]) {
          return this.state.errors;
        }

        const errors = { ...this.state.errors };
        delete errors[name];
        return errors;
      },

      // Valida la configuración Sentilo y marca en rojo los campos con error
      validateSentiloForm() {
        const data = this.state.sentiloEditData;
        const errors = {};

        // Si Sentilo no está habilitado no hay nada que validar
        if (data.enabled) {
          if (!data.componentName || !data.componentName.trim()) {
            errors.componentName = 'El nombre del componente es obligatorio';
          }

          if (!data.location || !data.location.trim()) {
            errors.location = 'La ubicación GPS es obligatoria';
          } else {
            const gpsRegex = /^-?\d+\.?\d*\s+-?\d+\.?\d*$/;
            if (!gpsRegex.test(data.location)) {
              errors.location = 'Formato inválido. Use: latitud longitud (ej: 39.27 -0.57)';
            }
          }

          const suffixRegex = /^S[0-9]{2}$/i;

          if (data.sensors.out0.enabled) {
            const suffix = data.sensors.out0.sensorSuffix;
            if (!suffix || !suffix.trim()) {
              errors['sensors.out0.sensorSuffix'] = 'El sufijo del sensor OUT0 es obligatorio';
            } else if (!suffixRegex.test(suffix)) {
              errors['sensors.out0.sensorSuffix'] = 'Formato: S + 2 dígitos (ej: S01)';
            }
          }

          if (data.sensors.out1.enabled) {
            const suffix = data.sensors.out1.sensorSuffix;
            if (!suffix || !suffix.trim()) {
              errors['sensors.out1.sensorSuffix'] = 'El sufijo del sensor OUT1 es obligatorio';
            } else if (!suffixRegex.test(suffix)) {
              errors['sensors.out1.sensorSuffix'] = 'Formato: S + 2 dígitos (ej: S01)';
            }
          }
        }

        this.update({ errors });

        if (Object.keys(errors).length > 0) {
          ToastService.error('Revisá los campos marcados en rojo');
          return false;
        }

        return true;
      },

      /**
       * Check if device has at least one Sentilo sensor configured
       */
      hasSentiloSensorsConfigured() {
        const config = this.props.device?.sentiloConfig;
        if (!config?.enabled) return false;
        if (!config.componentName || !config.location) return false;

        const out0Valid = config.sensors?.out0?.enabled && config.sensors?.out0?.sensorName;
        const out1Valid = config.sensors?.out1?.enabled && config.sensors?.out1?.sensorName;

        return out0Valid || out1Valid;
      },

      /**
       * Get registration status for a specific sensor channel
       * Returns: 'registered', 'not-registered', 'not-configured', or 'unknown'
       */
      getSensorRegistrationStatus(channel) {
        // If sensor is not configured/enabled, don't show status
        const sensorConfig = this.props.device?.sentiloConfig?.sensors?.[channel];
        if (!sensorConfig?.enabled || !sensorConfig?.sensorName) {
          return 'not-configured';
        }

        // If we haven't checked Sentilo yet, status is unknown
        if (!this.state.sentiloStatus.checked) {
          return 'unknown';
        }

        // Find the sensor in the status response
        const statusSensor = this.state.sentiloStatus.sensors?.find(s => s.channel === channel);
        if (!statusSensor) {
          return 'unknown';
        }

        return statusSensor.registeredInSentilo ? 'registered' : 'not-registered';
      },

      /**
       * Register device sensors in Sentilo/Dival platform
       */
      async handleRegisterSentiloSensors(e) {
        e.preventDefault();

        if (this.state.registeringSentilo) return;

        if (!this.hasSentiloSensorsConfigured()) {
          ToastService.error('Configure al menos un sensor antes de registrar');
          return;
        }

        try {
          this.update({ registeringSentilo: true });

          const result = await DeviceService.registerSentiloSensors(this.props.device._id);

          if (result.success) {
            ToastService.success(`Sensores registrados en Sentilo: ${result.sensors?.join(', ')}`);
            // Actualizar estado de Sentilo después de registrar
            this.checkSentiloStatus(this.props.device._id);
          } else {
            ToastService.error(`Error: ${result.message}`);
          }
        } catch (error) {
          console.error('Error registering Sentilo sensors:', error);
          ToastService.error(`Error al registrar: ${error.message || 'Error desconocido'}`);
        } finally {
          this.update({ registeringSentilo: false });
        }
      },

      /**
       * Check Sentilo registration status for this device
       */
      async checkSentiloStatus(deviceId) {
        if (!deviceId) return;

        this.update({
          sentiloStatus: {
            ...this.state.sentiloStatus,
            loading: true,
            error: null
          }
        });

        try {
          const result = await DeviceService.getSentiloStatus(deviceId);

          if (result.success) {
            this.update({
              sentiloStatus: {
                loading: false,
                checked: true,
                error: result.sentiloError || null,
                allSensorsRegistered: result.allSensorsRegistered || false,
                someSensorsRegistered: result.someSensorsRegistered || false,
                sensors: result.sensors || [],
                sentiloEnabled: result.sentiloEnabled
              }
            });
          } else {
            this.update({
              sentiloStatus: {
                ...this.state.sentiloStatus,
                loading: false,
                checked: true,
                error: result.error || 'Error desconocido'
              }
            });
          }
        } catch (error) {
          console.error('Error checking Sentilo status:', error);
          this.update({
            sentiloStatus: {
              ...this.state.sentiloStatus,
              loading: false,
              checked: true,
              error: error.message || 'Error al verificar estado'
            }
          });
        }
      },

      /**
       * Manually refresh Sentilo status
       */
      handleRefreshSentiloStatus(e) {
        e.preventDefault();
        if (this.props.device?._id) {
          this.checkSentiloStatus(this.props.device._id);
        }
      },

      async handleSaveSentiloConfig(e) {
        e.preventDefault();

        if (this.state.savingSentilo) return;

        if (!this.validateSentiloForm()) {
          return;
        }

        try {
          this.update({ savingSentilo: true });

          // Build full sensor names from component name + suffix
          const componentName = this.state.sentiloEditData.componentName;
          const sentiloConfigForBackend = {
            enabled: this.state.sentiloEditData.enabled,
            componentName: componentName,
            location: this.state.sentiloEditData.location,
            sensors: {
              out0: {
                enabled: this.state.sentiloEditData.sensors.out0.enabled,
                sensorName: this.getFullSensorName('out0'),
                description: this.state.sentiloEditData.sensors.out0.description
              },
              out1: {
                enabled: this.state.sentiloEditData.sensors.out1.enabled,
                sensorName: this.getFullSensorName('out1'),
                description: this.state.sentiloEditData.sensors.out1.description
              }
            }
          };

          const updatedDevice = await DeviceService.updateDevice(
            this.props.device._id,
            {
              name: this.props.device.name,
              tagid: this.props.device.tagid,
              sentiloConfig: sentiloConfigForBackend
            }
          );

          this.update({
            sentiloEditMode: false,
            savingSentilo: false
          });

          ToastService.success('Configuración de Sentilo actualizada correctamente');

          if (this.props.ondeviceupdated) {
            this.props.ondeviceupdated(updatedDevice);
          }
        } catch (error) {
          console.error('Error saving Sentilo config:', error);
          ToastService.error(`Error al guardar: ${error.message || 'Error desconocido'}`);
          this.update({ savingSentilo: false });
        }
      }
    }
  </script>
</device-sentilo-config>
